import { Table, TableColumnsType } from 'antd'
import React from 'react'
import { ExpandedDataType } from './types'

const expandedRowRender = (dataSource) => {
  const columns: TableColumnsType<ExpandedDataType> = [
    { title: 'バリエーション', dataIndex: 'variation', key: 'variation' },
    { title: '表示', dataIndex: 'display', key: 'display' },
    { title: '背景色', dataIndex: 'color', key: 'color' },
  ]

  return <Table columns={columns} dataSource={dataSource} pagination={false} />
}

export default expandedRowRender
